import React from 'react'

import { ICheckboxInputProps } from './types';

import {
  ToggleContainer,
  ToggleInput,
  ToggleSlider,
} from './styled';

const Toggle = React.forwardRef<HTMLInputElement, ICheckboxInputProps>(
  ({
    testId,
    ...inputProps
  }, ref) =>
    <ToggleContainer data-testid={testId} >
      <ToggleInput {...inputProps} type="checkbox" ref={ref} />
      <ToggleSlider />
    </ToggleContainer>
);

Toggle.displayName = 'UnfoldToggle';

export default Toggle;